import { render, staticRenderFns } from "./ContaAzul.vue?vue&type=template&id=a55b5a0e&"
import script from "./ContaAzul.vue?vue&type=script&lang=js&"
export * from "./ContaAzul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports